var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMissedThings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 66,
    viewBox: "0 0 47 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8959 4V23.4557C45.8959 26.7435 45.0339 29.9739 43.3959 32.8246V32.8246M3.89587 4V20.8049C3.89587 25.7575 5.64625 30.5507 8.83778 34.3378L9.39587 35",
    stroke: "#545454",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8959 35L27.1767 32.628C28.4128 32.2252 29.7572 32.3199 30.9248 32.8917L32.8959 33.8571",
    stroke: "#545454",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4609 45.2567L4.92125 39.3275C4.52732 38.9058 4.58331 38.2407 5.12675 38.0467C6.46471 37.5691 8.69369 37.5294 11.2518 39.1229C13.9015 40.7736 16.4773 42.8695 18.9401 44.1894C20.0679 44.7938 21.4059 44.7228 22.5767 44.2066L44.5113 34.5357C44.8124 34.403 45.1448 34.3578 45.4704 34.4054C46.7372 34.5906 47.3829 36.0287 46.6795 37.0984L46.2731 37.7165C46.1144 37.9579 45.91 38.1661 45.6715 38.3293L39.288 42.697C38.4649 43.2602 37.9304 44.1562 37.8261 45.1481C37.7264 46.0949 37.2345 46.9566 36.4699 47.5238L36.3371 47.6223C35.7083 48.0888 35.2399 48.7391 34.9968 49.4834L34.7552 50.2232C34.4836 51.0545 33.8948 51.7523 33.1237 52.1647C32.1948 52.6613 31.5446 53.5696 31.3815 54.6102C31.2415 55.5039 30.7467 56.3033 30.0093 56.8273L29.1955 57.4057L19.1072 63.4404C17.5053 64.3986 15.5031 64.3848 13.9146 63.4045L6.57188 58.873C5.4055 58.1532 5.29235 56.5 6.34979 55.628L10.1174 52.5211C12.3546 50.6762 12.514 47.3045 10.4609 45.2567Z",
    fill: "#ECBE08"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6897 38.9035L29.0821 47.0623M36.6479 47.1976L29.4326 50.9746M33.155 52.033L29.7329 54.3281",
    stroke: "#ECBE08",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8959 12L26.9788 18.9099C27.4916 20.6111 26.5733 22.4142 24.8959 23V23",
    stroke: "#545454",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissedThings);
export default __webpack_public_path__ + "static/media/missed-things.ccc07ba77ada4cf9d1f4e379a1a73309.svg";
export { ForwardRef as ReactComponent };